import React, {Component} from 'react';

export default class PopUp extends Component {
  constructor() {
    super();
    this.state = {
      content: {
        year: null,
        month: null,
        date: null,
        color: null,
        type: null
      }
    }
  }
  componentWillReceiveProps(nextProps){
    console.log(nextProps);
    if(nextProps.items && nextProps.selectedId){
      this.setState({content: nextProps.items[nextProps.selectedId]});
    }
  }

  zeropad(num) {
    return ('00'+num).slice(-2);
  }

  sendData(e){
    e.preventDefault();
    this.props.sendData(this.props.selectedDate);
  }

  render() {
    return (
      <div style={{display:"none"}}>
        <div id="popup">
          <div className="modal-cover">
            <div className="result-box">
              <div className="title-box" style={{backgroundColor: this.state.content.color}}>
                <p className="year">{Math.floor(this.state.content.year % 100 /10)*10}'s</p>
                <p className="title">{this.state.content.month}-{this.state.content.date}</p>
              </div>
              <p className="photo">
                <img src={`/assets2/feature/peanuts/print_image/${this.state.content.year}_${this.zeropad(this.state.content.month)}_${this.zeropad(this.state.content.date)}_${this.state.content.type}.png`} alt=""/>
              </p>

              <div className="button-box">
                <p className="btn-cart">
                  <a
                    href="#"
                    onClick={this.sendData.bind(this)}
                    className='js-noaclink'
                  >
                    カートに追加
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./source/javascripts/components/pop-up.js